import { formatDateTime } from '../../utils/format'

const STORAGE_ITEM_ID = 'logs.history'
const MAX_LOG_COUNT = 50

export class PersistentLogger {
  static getLogs() {
    const logsRaw = sessionStorage.getItem(STORAGE_ITEM_ID)
    return JSON.parse(logsRaw || '[]') as (string | object)[]
  }

  static storeLog(log: string | object) {
    const currentLogs = this.getLogs()
    const updatedLogs = [
      {
        timestamp: formatDateTime(new Date()),
        ...(typeof log === 'string' ? { message: log } : log),
      },
      ...currentLogs.slice(0, MAX_LOG_COUNT - 1),
    ]

    return sessionStorage.setItem(STORAGE_ITEM_ID, JSON.stringify(updatedLogs))
  }

  static log(log: string | object) {
    // console.log(log)
    this.storeLog(log)
  }
}
